import 'bootstrap/dist/css/bootstrap.css';
import '../../../styles/forms.css.js';
import React__default, { useState } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { styled } from 'styled-components';

const StyledTypeahead = styled(Typeahead) `
  :root {
    --rbt-color-primary: #ff0000 !important;
    --rbt-color-disabled: #495057 !important;
    --rbt-color-white: #fff !important;
  }

  .form-control-lg:focus,
  .form-control-sm:focus,
  .form-control:focus,
  .form-select:focus,
  .form-check-input:focus {
    border-color: #8a00e5 !important;
    box-shadow: none !important;
    outline: none !important;
  }

  .rbt .rbt-input-main::-ms-clear {
    display: none !important;
  }

  input.rbt-input-hint {
    display: none !important;
  }

  .rbt-menu {
    margin-top: 2px !important;
    margin-bottom: 2px !important;

    & > .dropdown-item {
      overflow: hidden !important;
      text-overflow: ellipsis !important;

      &.focus,
      &.hover,
      &.active {
        outline: none !important;
        color: #000000 !important;
        background-color: #fafafa !important;
      }

      &:active {
        background-color: #e9ddf0 !important;
        color: #000000 !important;
      }
    }

    &-pagination-option {
      text-align: center !important;
    }
  }

  $rbt-background-color-disabled: #e9ecef !important;

  $rbt-border-color-focus: #8a00e5 !important;
  $rbt-border-color-focus-invalid: #dc3545 !important;
  $rbt-border-color-focus-valid: #28a745 !important;

  $rbt-box-shadow-dimensions: 0 0 0 0.2rem !important;
  $rbt-box-shadow-color: rgba(0, 123, 255, 0.25) !important;
  $rbt-box-shadow-color-invalid: rgba(220, 53, 69, 0.25) !important;
  $rbt-box-shadow-color-valid: rgba(40, 167, 69, 0.25) !important;

  $rbt-color-focus: #495057 !important;
  $rbt-placeholder-color: #6c757d !important;

  .rbt-input-multi {
    cursor: text !important;
    overflow: hidden !important;
    position: relative !important;

    // Apply Bootstrap focus styles
    &.focus {
      border-color: #8a00e5 !important;
      /*  box-shadow: $rbt-box-shadow-dimensions $rbt-box-shadow-color !important; */
      color: $rbt-color-focus !important;
      outline: 0 !important;
    }

    &.form-control {
      height: auto !important;
    }

    // BS4 uses the :disabled pseudo-class, which doesn't work with non-inputs.
    &.disabled {
      background-color: $rbt-background-color-disabled !important;
      opacity: 1 !important;
    }

    &.is-invalid.focus {
      border-color: $rbt-border-color-focus-invalid !important;
      /*   box-shadow: $rbt-box-shadow-dimensions $rbt-box-shadow-color-invalid !important; */
    }

    &.is-valid.focus {
      border-color: $rbt-border-color-focus-valid !important;
      /*   box-shadow: $rbt-box-shadow-dimensions $rbt-box-shadow-color-valid !important; */
    }

    // Apply Bootstrap placeholder styles
    input {
      // Firefox
      &::-moz-placeholder {
        color: $rbt-placeholder-color !important;
        opacity: 1 !important;
      }

      // Internet Explorer 10+
      &:-ms-input-placeholder {
        color: $rbt-placeholder-color !important;
      }

      // Safari and Chrome
      &::-webkit-input-placeholder {
        color: $rbt-placeholder-color !important;
      }
    }

    .rbt-input-wrapper {
      align-items: flex-start !important;
      display: flex !important;
      flex-wrap: wrap !important;
      margin-bottom: -4px !important;
      margin-top: -1px !important;
      overflow: hidden !important;
    }

    .rbt-input-main {
      margin: 1px 0 4px !important;
    }
  }

  $rbt-token-background-color: #e7f4ff !important;
  $rbt-token-color: $rbt-color-primary !important;
  $rbt-token-disabled-background-color: rgba(0, 0, 0, 0.1) !important;
  $rbt-token-disabled-color: $rbt-color-disabled !important;
  $rbt-token-active-background-color: $rbt-color-primary !important;
  $rbt-token-active-color: $rbt-color-white !important;

  .rbt-token {
    background-color: #f5f5f5 !important;
    border: 0 !important;
    border-radius: 0.25rem !important;
    color: #000000 !important;
    display: inline-flex !important;
    line-height: 1rem !important;
    margin: 1px 3px 2px 0 !important;

    &:hover {
      background-color: #f0f0f0 !important;
    }

    .rbt-token-label {
      padding: 0.25rem 0.5rem !important;

      &:not(:last-child) {
        padding-right: 0.25rem !important;
      }
    }

    &-disabled {
      background-color: $rbt-token-disabled-background-color !important;
      color: $rbt-token-disabled-color !important;
      pointer-events: none !important;
    }

    &-removeable {
      cursor: pointer !important;
    }

    &-active {
      background-color: #e9ddf0 !important;
      color: #000000 !important;
      outline: none !important;
      text-decoration: none !important;

      &:hover {
        background-color: #e9ddf0 !important;
      }
    }
    &-remove-button {
      background-image: none !important;
      border-bottom-left-radius: 0 !important;
      border-top-left-radius: 0 !important;
      box-shadow: none !important;
      color: inherit !important;
      display: flex !important;
      justify-content: center !important;
      font-size: inherit !important;
      font-weight: normal !important;
      opacity: 1 !important;
      outline: none !important;
      padding: 0.25rem 0.5rem !important;
      padding-left: 0 !important;
      text-shadow: none !important;

      .rbt-close-content {
        display: block !important;
      }
    }
  }
  .rbt-aux {
    align-items: center !important;
    display: flex !important;
    bottom: 0 !important;
    justify-content: center !important;
    pointer-events: none !important;
    position: absolute !important;
    right: 0 !important;
    top: 0 !important;
    width: 2rem !important;

    &-lg {
      width: 3rem !important;
    }

    & .rbt-close {
      margin-top: -0.25rem !important;
      pointer-events: auto !important;
    }
  }

  .has-aux .form-control {
    padding-right: 2rem !important;

    &.is-valid,
    &.is-invalid {
      background-position: right 2rem center !important;
      padding-right: 4rem !important;
    }
  }

  .rbt-highlight-text {
    background-color: #e9ddf0 !important;
    color: inherit !important;
    padding: 0 !important;
  }

  .input-group > .rbt {
    flex: 1 !important;

    & .rbt-input-hint,
    & .rbt-aux {
      z-index: 5 !important;
    }

    &:not(:first-child) .form-control {
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
    }

    &:not(:last-child) .form-control {
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
  }
`;
const AutocompleteComponent = ({ id, options, selected = [], size = undefined, disabled = false, dropup = false, flip = true, minLength = 0, open = undefined, multiple = false, labelKey = 'label', placeholder, maxHeight, emptyLabel = 'No matches found', ...props }) => {
    const [selections, setSelections] = useState(selected);
    let sizeComp = undefined;
    if (size === 'large')
        sizeComp = 'lg';
    if (size === 'small')
        sizeComp = 'sm';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChange = (value) => {
        setSelections(value);
        if (props.onChange) {
            props.onChange(value);
        }
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(StyledTypeahead, { id: id, size: sizeComp, disabled: disabled, dropup: dropup, flip: flip, minLength: minLength, open: open, multiple: multiple, labelKey: labelKey, emptyLabel: emptyLabel, selected: selections, maxHeight: maxHeight ? maxHeight + 'px' : undefined, placeholder: placeholder, onChange: handleChange, options: options })));
};
const Autocomplete = (props) => {
    return React__default.createElement(AutocompleteComponent, { ...props });
};

export { Autocomplete as default };
//# sourceMappingURL=Autocomplete.js.map
